import { formatDollars } from '~/cynqueModules/formatDollars'

declare module 'vue' {
  interface ComponentCustomProperties {
    $formatDollars(amount: number | undefined | null): string
  }
}

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.config.globalProperties.$formatDollars = (
    amount: number | undefined | null
  ) => {
    return formatDollars(amount)
  }
})
